/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2023-09-19 15:02:51
 * @LastEditTime: 2023-10-11 16:30:35
 * @LastEditors: WangYuhan
 */
/* eslint-disable camelcase */
// 引入api请求方法
import { pageContract } from '@/api/info';

const state = {
  // 接口调用参数
  postParams: {
    bid: '',
    size: 20,
    page: 1,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '合同名称',
        prop: 'name',
        checked: 1,
        sortable: true,
      },
      {
        label: '状态',
        prop: 'desc',
        checked: 1,
        sortable: true,
      },
      {
        label: '经办人',
        prop: 'operator',
        checked: 1,
        sortable: true,
      },
      {
        label: '完成时间',
        prop: 'validity',
        checked: 1,
        sortable: true,
      },
      {
        label: '合同类型',
        prop: 'type',
        checked: 1,
        sortable: true,
      },
    ],
    total: 0,
  },
  invoiceAmountData: '',
  totalAccount: '',
  showTableResult: false,
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    if (window.localStorage.businessId) {
      context.state.postParams.bid = window.localStorage.businessId;
      const { data } = await pageContract(context.state.postParams);
      context.commit('updateListData', Object.assign({}, context.state.listData, data));
    } else {
      window.location.href = '/enterprise/enterpriseInfo';
    }
  },
};

// mutations
const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = payload;
  },
  // 更新列表表头数据
  updateEditTableList(state, payload) {
    state.listData.tableHeadList = payload;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  updateShowTableResult(state, payload) {
    state.showTableResult = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
